<div
	class="message"
	[class.user-message]="!isAssistant"
	[class.assistant-message]="isAssistant"
	(mouseenter)="hovering = true"
	(mouseleave)="hovering = false"
	role="article"
	data-testid="message-container"
>
	<!-- User Message -->
	@if (!isAssistant) {
		<div class="user-bubble">
			<p class="message-text">{{ message.content }}</p>
			<!-- File Badge -->
			@if (message.fileName) {
				<div class="file-badge">
					<mat-icon class="file-icon">description</mat-icon>
					<span class="file-name">{{ message.fileName }}</span>
				</div>
			}
		</div>
		<div class="user-actions">
			<span class="timestamp">{{ formattedTime }}</span>
			<app-button
				variant="icon"
				category="action"
				size="xs"
				[iconName]="copied ? 'done' : 'content_copy'"
				tooltip="Copy"
				[onClick]="copyToClipboardAction"
				[attr.aria-label]="copied ? 'Copied' : 'Copy message'"
			>
			</app-button>
		</div>
	}

	<!-- Assistant Message -->
	@if (isAssistant) {
		<div class="assistant-content">
			<!-- Paragraph-level footnotes when multiple paragraphs match sources -->
			@if (!(useParagraphFootnotes && !isProgressiveRendering)) {
				<markdown class="message-text" [data]="sanitizedContent"></markdown>
				@if (isProgressiveRendering) {
					<span class="progressive-cursor"></span>
				}
			}

			@if (isProgressiveRendering) {
				<button class="skip-animation-btn" (click)="skipAnimation()" data-testid="message-btn-skip-animation">Skip animation</button>
			}

			@if (hasSources) {
				<app-source-citation
					[sources]="message.sources!"
					[mode]="message.mode"
					[isSidecar]="isSidecar"
					[userQuery]="userQuery"
					(viewDocument)="viewDocument.emit($event)"
					(requestFullscreen)="requestFullscreen.emit($event)"
				>
				</app-source-citation>
			}

			<!-- Artifact triggers -->
			@if (artifactBlocks.length > 0) {
				<div class="form-triggers">
					@for (artifact of artifactBlocks; track artifact.title) {
						<button class="form-trigger-btn" (click)="openArtifact.emit(artifact)" data-testid="message-btn-open-artifact">
							<mat-icon>article</mat-icon>
							View: {{ artifact.title }}
						</button>
					}
				</div>
			}

			<div class="metadata-bar">
				<span class="metadata-text">{{ metadataText }}</span>
				<app-feedback-rating [messageId]="message.id" [currentFeedback]="message.feedback" (feedbackSubmitted)="onFeedbackSubmitted($event)"> </app-feedback-rating>
				<app-button
					variant="icon"
					category="action"
					size="xs"
					[iconName]="copied ? 'done' : 'content_copy'"
					tooltip="Copy"
					[onClick]="copyToClipboardAction"
					[attr.aria-label]="copied ? 'Copied' : 'Copy response'"
				>
				</app-button>
			</div>
		</div>
	}
</div>
